"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@loadsure/utils");
const fees_1 = require("../../fees");
class CoverageCostCalc {
    constructor(minLimit, maxLimit, premium, deductible, serviceFees, productId, forceLimits, referral) {
        this.minLimit = minLimit;
        this.maxLimit = maxLimit;
        this.premium = premium;
        this.deductible = deductible;
        this.serviceFees = serviceFees;
        this.productId = productId;
        this.forceLimits = forceLimits;
        this.referral = referral;
        this.limitRange = new utils_1.NumberRange(minLimit, maxLimit);
    }
    static fromObj(data) {
        const minLimit = data.minLimit
            ? utils_1.NumberComparison.fromObj(data.minLimit)
            : undefined;
        const maxLimit = data.maxLimit
            ? utils_1.NumberComparison.fromObj(data.maxLimit)
            : undefined;
        const premium = data.premium
            ? utils_1.Calculation.fromObj(data.premium)
            : undefined;
        const deductible = data.deductible
            ? utils_1.Calculation.fromObj(data.deductible)
            : undefined;
        const serviceFees = Array.isArray(data.serviceFees)
            ? data.serviceFees.map(fees_1.feeComponentFromObj).filter(utils_1.isObjectDefined)
            : undefined;
        return new CoverageCostCalc(minLimit, maxLimit, premium, deductible, serviceFees, data.productId, !!data.forceLimits, data.referral);
    }
}
exports.default = CoverageCostCalc;
//# sourceMappingURL=coverageCostCalc.class.js.map